<template>
    <div class="call-history-wrapper">
        <div class="call-history-header">
            <div class="d-flex align-items-center h-100">
                <h6
                    class="fw-semibold mb-0 text-app-secondary"
                    v-if="callFilterType == 'All' || callFilterType == null"
                >
                    Call History
                </h6>
                <h6 class="fw-semibold mb-0 text-app-secondary" v-else>
                    <i class="fas fa-chevron-left me-3 cursor-pointer" @click="filterCallLog('All')"></i
                    ><span>
                        {{ callFilterType ? CallType.getDescriptionUsingValue(callFilterType) : "" }}
                    </span>
                </h6>
                <div class="ms-auto">
                    <div
                        class="dropdown"
                        v-tooltip="{ title: `Filter by Call Type`, placement: 'left', trigger: `hover` }"
                    >
                        <img
                            class="cursor-pointer"
                            src="../../../assets/images/chat/filter-bar.svg"
                            data-bs-toggle="dropdown"
                        />
                        <div class="dropdown-menu py-1 px-2 sort-dropdown-menu" aria-labelledby="Chat-Options">
                            <a
                                class="dropdown-item sort-dropdown"
                                href="javascript:void(0);"
                                id="all-filter"
                                @click="filterCallLog('All')"
                            >
                                <div class="d-flex justify-content-between">
                                    All
                                    <img class="sort-type-icon" src="../../../assets/images/chat/all-calls.svg" />
                                </div>
                            </a>
                            <a
                                class="dropdown-item sort-dropdown"
                                href="javascript:void(0);"
                                id="outgoing-filter"
                                @click="filterCallLog(CallType.enum.Outgoing)"
                            >
                                <div class="d-flex justify-content-between">
                                    Outgoing
                                    <img class="sort-type-icon" src="../../../assets/images/chat/outgoing-call.svg" />
                                </div>
                            </a>
                            <a
                                class="dropdown-item sort-dropdown"
                                href="javascript:void(0);"
                                id="incoming-filter"
                                @click="filterCallLog(CallType.enum.Incoming)"
                            >
                                <div class="d-flex justify-content-between">
                                    Incoming
                                    <img class="sort-type-icon" src="../../../assets/images/chat/incoming-call.svg" />
                                </div>
                            </a>
                            <a
                                class="dropdown-item sort-dropdown"
                                href="javascript:void(0);"
                                id="missed-filter"
                                @click="filterCallLog(CallType.enum.Missed)"
                            >
                                <div class="d-flex justify-content-between">
                                    Missed
                                    <img class="sort-type-icon" src="../../../assets/images/chat/missed-call.svg" />
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="search-input p-3 bg-white d-md-none border-bottom">
            <CallSearch />
        </div>
        <ScrollPagination
            class="content-y h-100"
            :page-number="pageNumber"
            :all-pages-loaded="allPagesLoaded"
            :is-loading="loadMore"
            :has-error="hasError"
            v-on:pageNumberUpdate="pageNumberUpdated"
        >
            <ul
                class="nav scroll-paginate list-group list-group-flush message-navigation"
                :class="{ 'custom-scrollbar': userOs == 'Windows' }"
            >
                <template v-if="!isLoading && callHistoryList && callHistoryList.length > 0">
                    <li
                        v-for="callDetail in callHistoryList"
                        :key="callDetail.id"
                        class="nav-item list-group-item message-list-item call-list call-list-height"
                    >
                        <div class="d-flex justify-content-between align-items-center min-width-0 h-100">
                            <div class="d-flex align-items-center">
                                <AvaInitials
                                    classes="me-1"
                                    :initialsType="callDetail?.conversationType"
                                    :user="getInitials(callDetail.callParticipants)"
                                    :showStatus="true"
                                />
                                <div class="ps-2 flex-grow-1 min-width-0">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <span class="mb-1 fw-bold text-dark">
                                            <span v-if="callDetail.title"> {{ callDetail.title }}</span>
                                            <span v-else>
                                                {{
                                                    formatDisplayUsers(
                                                        getCallParticipants(callDetail?.callParticipants)
                                                    )
                                                }}
                                            </span>
                                        </span>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="text-truncate me-2">
                                            <span v-if="callDetail.callHistoryType == CallType.enum.Incoming">
                                                <img src="../../../assets/images/chat/incoming-call.svg" />
                                            </span>
                                            <span v-if="callDetail.callHistoryType == CallType.enum.Outgoing">
                                                <img src="../../../assets/images/chat/outgoing-call.svg" />
                                            </span>
                                            <span v-if="callDetail.callHistoryType == CallType.enum.Missed">
                                                <img src="../../../assets/images/chat/missed-call.svg" />
                                            </span>
                                            <span
                                                class="ms-2 d-none d-md-inline"
                                                :class="{
                                                    'text-danger': callDetail.callHistoryType == CallType.enum.Missed
                                                }"
                                                >{{
                                                    CallType.getDescriptionUsingValue(callDetail.callHistoryType)
                                                }}</span
                                            >
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center">
                                <span
                                    class="ms-2 ms-lg-0 me-2 call-duration-width"
                                    v-if="callDetail.callHistoryType != CallType.enum.Missed"
                                    >{{ callDetail.callDuration }}</span
                                >
                                <span class="mx-2 mx-lg-5 call-time-width d-none d-md-inline">{{
                                    formatDateTimeToLocal(callDetail.callStartTime)
                                }}</span>
                                <span
                                    class="ms-1"
                                    @click="
                                        !dialogOpened && startMeeting(ConversationRoomTypeEnum.VideoCall, callDetail)
                                    "
                                    :class="[
                                        dialogOpened ? 'cursor-not-allowed' : 'cursor-pointer',
                                        callDetail.isDeletedParticipant == true ? 'hidden' : 'cursor-pointer'
                                    ]"
                                    ><img src="../../../assets/images/chat/video-call-icon.svg"
                                /></span>
                                <span
                                    class="mx-2 mx-lg-4"
                                    @click="
                                        !dialogOpened && startMeeting(ConversationRoomTypeEnum.AudioCall, callDetail)
                                    "
                                    :class="[
                                        dialogOpened ? 'cursor-not-allowed' : 'cursor-pointer',
                                        callDetail.isDeletedParticipant == true ? 'hidden' : 'cursor-pointer'
                                    ]"
                                    ><img src="../../../assets/images/chat/voice-call.svg"
                                /></span>
                                <span
                                    :class="[callDetail.isDeletedParticipant == true ? 'hidden' : 'cursor-pointer']"
                                    class="cursor-pointer"
                                    @click="navigateToConversation(callDetail.conversationId)"
                                >
                                    <img src="../../../assets/images/chat/messenger-icon.svg" />
                                </span>
                            </div>
                        </div>
                    </li>
                    <li class="py-1" v-if="loadMore">
                        <div class="loader-parent">
                            <div class="msg-loader"></div>
                        </div>
                    </li>
                </template>
                <li
                    v-if="!isLoading && callHistoryList?.length == 0"
                    class="nav-item list-group-item text-dark h-100 d-flex justify-content-center text-middle flex flex-column"
                >
                    <h5 class="text-center">No Call History Found.</h5>
                </li>
                <template v-if="isLoading">
                    <li
                        v-for="i in 9"
                        :key="i"
                        class="nav-item list-group-item call-list-height d-flex justify-content-center text-middle flex flex-column"
                    >
                        <div class="d-flex align-items-center">
                            <div class="ava-initials me-1">
                                <span></span>
                            </div>
                            <div class="ms-2 flex-grow-1">
                                <span class="shimmer-loading w-90 lighten"></span>
                                <div class="message-content">
                                    <span class="shimmer-loading w-70 lighten"></span>
                                </div>
                            </div>
                        </div>
                    </li>
                </template>
            </ul>
        </ScrollPagination>
    </div>
</template>
<script lang="ts" src="./CallHistory.ts"></script>
<style src="./CallHistory.scss"></style>
